import BaseEntity from '../..//BaseEntity';
import PaxPrice from '../../basic-types/PaxPrice';
import { fromJsonArrayWith } from '../../index';

export default class Product extends BaseEntity {
    public name: string;
    public subtitle: string;
    public visible: boolean;
    public freeCompanionPerPax: number;
    public schoolOffer: boolean;
    public paxPrices: PaxPrice[];

    constructor(json: any) {
        super(json);

        this.name = json.name;
        this.subtitle = json.subtitle;
        this.visible = json.visible;
        this.freeCompanionPerPax = json.freeCompanionPerPax;
        this.schoolOffer = json.schoolOffer;
        this.paxPrices = fromJsonArrayWith(PaxPrice.fromJson, json.paxPrices);
    }

    public toString(): string {
        return this.name;
    }
}
